import React, { useState } from 'react';
import Modal from 'react-modal';
import Styles from './mascot-modal-styles.scss';
import ButtonKVBase from '../button-kv/button-kv';
import Cookies from 'js-cookie';
import { KEY_COOKIE_WELCOME, KEY_LS_WELCOME_BACK } from '@/presentation/constants/storage-keys';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { appTutorialDataAtom } from '../tutorial-app/tutorial-app-atom';
import { useRecoilState } from 'recoil';
const textByRole = {
    client: 'This is your Admin portal and hub for managing students, tracking their progress, downloading lesson plans, getting help, and even inviting your peers to join the fun.',
    clientEnterprise: 'This is your Admin portal and go-to spot for managing classrooms, teachers, and students, tracking progress, downloading lesson plans, getting help, viewing your profile, and more!',
    teacher: 'This is your educator portal and go-to spot for managing your classrooms, tracking progress, downloading lesson plans, getting help, viewing coursework, your profile, and more.',
    student: 'I’m here to help you get started on your journey to managing money, investing, launching your business, and building wealth! Let me show you how to view your work, grades, accounts, earn KV Bucks, trade and cash out like a pro!'
};
const MascotModal = ({ userId }) => {
    const [stateAppTutorialData, _] = useRecoilState(appTutorialDataAtom);
    // Check if the cookie exists to determine if modal should be shown
    const cookieValue = Cookies.get(`${KEY_COOKIE_WELCOME}_${userId}`);
    const [modal, setModal] = useState(!cookieValue && !(stateAppTutorialData === null || stateAppTutorialData === void 0 ? void 0 : stateAppTutorialData.currentView)); // Show modal if the cookie doesn't exist
    const [appTutorialState, setAppTutorialState] = useRecoilState(appTutorialDataAtom);
    // Check if the user has been welcomed before from localStorage
    const alreadyWelcome = localStorage.getItem(`${KEY_LS_WELCOME_BACK}_${userId}`) === 'true';
    const { user, getClient } = useUserSesssion();
    const customStyles = {
        content: {
            top: '72%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: `70vw`,
            transform: 'translate(-50%, -50%)',
            boxShadow: '15px 20px 50px 15px rgba(65, 65, 65, 0.08)'
        },
        overlay: {
            background: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999
        }
    };
    const closeModal = () => {
        try {
            // Set a cookie that expires in 24 hours
            Cookies.set(`${KEY_COOKIE_WELCOME}_${userId}`, 'true', { expires: 1 }); // expires in 1 day
            localStorage.setItem(`${KEY_LS_WELCOME_BACK}_${userId}`, 'true'); // Keep localStorage for message logic
        }
        catch (error) {
            console.error('Error closing modal', error);
        }
        setModal(false);
    };
    const onStartContinue = () => {
        closeModal();
        if (appTutorialState.skipped)
            return;
        setAppTutorialState({ currentView: 'STS_TOOL_BAR', skipped: false });
    };
    const onSkip = () => {
        closeModal();
        setAppTutorialState({ currentView: '', skipped: true });
    };
    const getText = () => {
        var _a, _b, _c, _d;
        if (((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) === 'Client') {
            const client = getClient();
            if ((_b = client === null || client === void 0 ? void 0 : client.plan) === null || _b === void 0 ? void 0 : _b.includes('enterprise')) {
                return textByRole.clientEnterprise;
            }
            return textByRole.client;
        }
        else if (((_c = user === null || user === void 0 ? void 0 : user.role) === null || _c === void 0 ? void 0 : _c.description) === 'Teacher') {
            return textByRole.teacher;
        }
        else if (((_d = user === null || user === void 0 ? void 0 : user.role) === null || _d === void 0 ? void 0 : _d.description) === 'Student') {
            return textByRole.student;
        }
    };
    if (!modal)
        return null;
    return (React.createElement(Modal, { isOpen: modal, onRequestClose: closeModal, style: customStyles, className: Styles.defaultModal },
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { style: { flex: 0.5 } },
                React.createElement("img", { className: Styles.mascotImage, alt: "Mascot" })),
            React.createElement("div", { style: { flex: 1 } },
                React.createElement("div", { className: Styles.modalContent },
                    React.createElement("div", { className: Styles.arrowLeft }),
                    React.createElement("div", { className: Styles.modalBody },
                        React.createElement("div", { className: Styles.title },
                            "Hi, ",
                            React.createElement("span", null, user === null || user === void 0 ? void 0 :
                                user.firstName,
                                "!")),
                        React.createElement("div", { className: Styles.subtitle }, alreadyWelcome ? 'Welcome Back!' : "Welcome to KidVestors! I'm Wally!"),
                        !alreadyWelcome && React.createElement("div", { className: Styles.text }, getText()),
                        React.createElement("div", null,
                            React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: onStartContinue }, alreadyWelcome ? 'Continue' : 'Start')),
                        !alreadyWelcome && (React.createElement("div", { className: Styles.skip },
                            React.createElement("button", { type: "button", onClick: onSkip }, "Skip Tutorial")))))))));
};
export default MascotModal;
